var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntersection2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546.03 61",
    style: {
      enableBackground: "new 0 0 546.03 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.53;fill:#1A8EB4;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    className: "st0",
    d: "M0,61V0h96.63C74.86,31.45,41.81,53.3,4.34,61H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    className: "st0",
    d: "M432.4,61c9.79-22.6,23.55-43.26,40.64-61h72.56v61H432.4z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection2);
export default __webpack_public_path__ + "static/media/Intersection2.9f8fdbff1f8cc8e8e585399d1070a56e.svg";
export { ForwardRef as ReactComponent };